import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { currencyFormat, getPrice, getPriceSymbole } from "../Helper";
import { useCart } from "../context/cart";
import { useAuth } from "../context/auth";
import LoginModalPopUp from "./LoginModalPopUp";
import NewLoginRegister from "../component/Layout/NewLoginRegister";
import CountdownTimer from "./CountdownTimer";

function MiniCart({ isCartActive, toggleCartClass }) {
  const symbol = getPriceSymbole();
  const [auth] = useAuth();
  const [CartItem, SetCartItem] = useState([]);
  const [getCartTotal, SetgetCartTotal] = useState(0);
  const [totalMrp, setTotalMrp] = useState("");
  const [onlineDiscount, setOnlineDiscount] = useState("");
  const [productDiscount, setProductDiscount] = useState(0);
  const [cart, setCart] = useCart();
  const [show, setShow] = useState(false);
  const [checkoutClick, setCheckoutClick] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [welcomeDiscountEnable, setWelcomeDiscountEnable] = useState(0);
  const [welcomeDiscountAmount, setWelcomeDiscountAmount] = useState(0);
  const [timeLeft] = useState(() => {
    const storedCountdown = parseInt(localStorage.getItem("countdown"));
    if (!isNaN(storedCountdown)) {
      return storedCountdown;
    }
  });
  const [isDiscountVisible, setIsDiscountVisible] = useState(() => {
    return auth?.user?.welcome_discount_use !== 1;
  });

  //console.log(welcomeDiscountEnable, timeLeft, isDiscountVisible);


  useEffect(()=>{
      if(!isDiscountVisible){
        setWelcomeDiscountAmount(0)
      }
  },[isDiscountVisible])
 

  // Function to fetch and update cart
  const updateCart = (cart) => {
    let curcart = cart?.length
      ? cart
      : JSON.parse(localStorage.getItem("cart")) || [];
    SetCartItem(curcart);
    SetgetCartTotal(
      curcart.reduce(
        (total, item) =>
          total +
          (item.discount ? item.price - item.discount : item.price) *
            item.quantity,
        0
      )
    );
    //setOnlineDiscount(getCartTotal * 0.05);
    setWelcomeDiscountAmount(
      auth?.user?.welcome_discount_use === 1
        ? 0
        : auth?.user?.id
        ? getCartTotal * 0.05
        : 0
    );
    setTotalMrp(
      curcart.reduce(
        (totalMrp, item) => totalMrp + item.price * item.quantity,
        0
      )
    );
    setProductDiscount(
      curcart.reduce(
        (totalMrpDiscount, item) =>
          totalMrpDiscount + item.discount * item.quantity,
        0
      )
    );
  };

  // Fetch cart from database after login
  const fetchCartFromDatabase = async () => {
    if (auth?.user) {
      try {
        const country_data = sessionStorage.getItem("country_data");
        let { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/cart?customer_id=${auth.user.id}&country_code=${JSON.parse(country_data)?.country_code}`
        );
        localStorage.setItem("cart", JSON.stringify(data));
        setCart(data);
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    }
  };

  // Remove item from cart (both local & database)
  const removeCartFromDatabase = async (item) => {
    if (item.id) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/cart/remove?id=${item.id}&customer_id=${item.customer_id}`
        );
      } catch (error) {
        console.error("Error removing cart item:", error);
      }
    }
  };

  const removeFromCart = (item) => {
    if (
      window.confirm("Are you sure you want to remove this item from the cart?")
    ) {
      removeCartFromDatabase(item);
      let updatedCart = CartItem.filter(
        (cart) =>
          cart.variant !== item.variant || cart.product_id !== item.product_id
      );

      localStorage.setItem("cart", JSON.stringify(updatedCart));
      setCart(updatedCart);
      updateCart(updatedCart);
    }
  };

  // Run cart update when `cart` or `auth` changes
  useEffect(() => {
    updateCart(cart);
  }, [cart, getCartTotal]);

  useEffect(() => {
    fetchCartFromDatabase();
  }, [auth]); // Fetch cart only after login

  const getWelComeDiscount = async () => {
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/static/welcomediscount`
    );
    if (data?.status) {
      setWelcomeDiscountEnable(data?.status);
    }
  };
  useEffect(() => {
    if (auth?.user?.id) {
      //console.log('===>>>***',auth?.user?.id)
      getWelComeDiscount();
    }
    //eslint-disable-next-line
  }, [auth?.user?.id]);
  const handleClick = (e) => {
    if (location.pathname === "/checkout") {
      e.preventDefault(); // Prevent navigation
      toggleCartClass();
    } else {
      navigate("/checkout");
    }
  };

  return (
    <>
      <div
        onClick={toggleCartClass}
        className={`minicart-box-overlay ${isCartActive ? "active" : ""}`}
      ></div>
      <div className={`minicart-box  ${isCartActive ? "active" : ""}`}>
        <div className="minicart-heading">
          <div className="heading">
            {" "}
            {cart?.length > 0 && (
              <>
                Cart <span>{cart?.length}</span>
              </>
            )}
          </div>{" "}
          <span className="close-cart" onClick={toggleCartClass}>
            &times;
          </span>
        </div>
        {CartItem.length > 0 ? (
          <>
            <ul className="minicart" style={{ display: "block" }}>
              {CartItem.map((item, i) => (
                <li key={i}>
                  <div className="cart-img">
                    <Link to={`/product/${item.slug}`} target="_blank">
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}/product/thumbnail/${item.thumbnail}`}
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="cart-info">
                    <h2>
                      <Link to={`/product/${item.slug}`} target="_blank">
                        {item.name}
                      </Link>
                    </h2>
                    <p>
                      Size: {item.variations.Size} ({item.variations.color})
                    </p>
                    <p>
                      {item.quantity} X{" "}
                      <span className="amount">
                        <bdi>
                          <span className="price-currencysymbol">{symbol}</span>
                          {item.discount
                            ? getPrice(item.price - item.discount)
                            : getPrice(item.price)}
                        </bdi>
                      </span>
                    </p>
                    <span className="delete-button">
                      <i
                        className="fa-regular fa-trash-can"
                        title="Delete"
                        onClick={() => removeFromCart(item)}
                      ></i>
                    </span>
                  </div>
                </li>
              ))}
            </ul>
            <div className="custom-cart-payment-box">
              <div className="cart_totals">
                <div className="cart-subtotal">
                  <p className="left-corner"> Total MRP </p>
                  <span className="right-corner">
                    {" "}
                    <span className="price-amount">
                      {symbol} {totalMrp && getPrice(totalMrp)}
                    </span>{" "}
                  </span>
                </div>
                <div className="shipping-total">
                  <p className="left-corner"> Shipping </p>
                  <span className="right-corner">Free shipping</span>
                </div>
                {productDiscount > 0 && (
                  <div className="cart-subtotal red-text">
                    <p className="left-corner"> Discount</p>
                    <span className="right-corner">
                      {" "}
                      <span className="price-amount">
                        - {symbol}{" "}
                        {productDiscount && getPrice(productDiscount)}
                      </span>{" "}
                    </span>
                  </div>
                )}
                {welcomeDiscountEnable === 1 &&
                  timeLeft > 0 &&
                  isDiscountVisible && (
                  <>
                    <div className="shipping-total red-text">
                      <p className="left-corner"> Tik Tok Discount (5%)</p>
                     
                      <span className="right-corner">
                        - {symbol} {getPrice(welcomeDiscountAmount)}
                      </span>
                    </div>
                   

                   <div className="shipping-timer">
                   <div> <span className="shipping-timer-box">Get 5% additional off before the timer runs out: </span> 
                   <span style={{ animation: "blink 1s linear infinite" }}><CountdownTimer initialSeconds={3600} onComplete={() => setIsDiscountVisible(false)} storageKey="countdown" /> </span> </div> <span></span>
                    </div> 

                   </>
                  )}
                <div className="shipping-total red-text" style={{display: 'none' }}>
                  <p className="left-corner"> Online Payment Discount (5%)</p>
                  <span className="right-corner">
                    - {symbol} {getPrice(onlineDiscount)}
                  </span>
                </div>
                <div className="order-total">
                  <p className="left-corner"> Total Amount</p>
                  <span className="right-corner">
                    <strong>
                      <span className="price-amount">
                        {symbol}{" "}
                        {getCartTotal &&
                          getPrice(
                            getCartTotal -
                              onlineDiscount -
                              welcomeDiscountAmount
                          )}
                      </span>
                    </strong>
                  </span>
                </div>
              </div>
            </div>
            {auth?.user ? (
              <div className="cart-bottom">
                <Link to="/checkout" onClick={handleClick}>
                  Checkout
                </Link>
                <Link
                  to="/category/shop?orderBy=default"
                  className="continue-shopping-btn"
                  onClick={toggleCartClass}
                >
                  Continue shopping
                </Link>
              </div>
            ) : (
              <div className="cart-bottom">
                <button
                  className="checkout-btn"
                  onClick={() => {
                    setShow(true);
                    setCheckoutClick(true);
                  }}
                >
                  Checkout
                </button>
                <Link
                  to="/category/shop?orderBy=default"
                  className="continue-shopping-btn"
                  onClick={toggleCartClass}
                >
                  Continue shopping
                </Link>
              </div>
            )}
            {/* <LoginModalPopUp
            show={show}
            checkoutClick={checkoutClick}
            handleClose={() => setShow(false)}
          /> */}
            {!auth?.user && (
              <NewLoginRegister
                show={show}
                redirect={true}
                locationPath={"checkoutPage"}
              />
            )}
          </>
        ) : (
          <div className="empty-cart">
            <div className="empty-cart-text">
              <div className="empty-cart-icon">
                <i className="fa-solid fa-cart-shopping"></i>
              </div>
              <h3 className="cart-empty">Your cart is empty.</h3>
              <div className="shoping-button">
                <Link
                  to="/category/shop?orderBy=default"
                  onClick={toggleCartClass}
                >
                  Continue shopping
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default MiniCart;
